export class Status {
	id:number;
	name:string;

	toString() {
		return this.name;
	}
}